import { render, staticRenderFns } from "./htmlSnippets.vue?vue&type=template&id=54560f96&scoped=true&lang=html&"
import script from "./htmlSnippets.vue?vue&type=script&lang=js&"
export * from "./htmlSnippets.vue?vue&type=script&lang=js&"
import style0 from "./htmlSnippets.vue?vue&type=style&index=0&id=54560f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54560f96",
  null
  
)

export default component.exports